import { render, staticRenderFns } from "./assign-discount.vue?vue&type=template&id=8c40cda6&"
import script from "./assign-discount.vue?vue&type=script&lang=js&"
export * from "./assign-discount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports